import { type Enum } from '@ui/utils/enums'

export const SupportedFileTypes = {
  PDF: 'pdf',
  IMAGE: 'image',
} as const

export type SupportedFileType = Enum<typeof SupportedFileTypes>
